import { Caption } from 'modules/design-system';
import styled from 'styled-components';

export namespace SSOSignInPageCSS {
  export const ProviderButtonContent = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${({ theme }) => theme.spacing.xxs};
  `;

  export const FormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing.m};
    width: 100%;
  `;

  export const Subtitle = styled(Caption)`
    margin: 0 0 ${({ theme }) => theme.spacing.m};
  `;
}
